@if (facade.row(); as r) {
  <div class="order-header">
    <div class="order-header__main">
      <div class="order-header__title-row">
        <div class="order-header__title-block">
          <div class="order-header__title-inline">
            <h1 class="order-header__name">{{ facade.displayTitle(r) }}</h1>
            <span class="order-header__public-id">{{
              facade.formatOrderShortPublicId(r.id)
            }}</span>
          </div>
        </div>
        <div class="order-header__aside">
          <span
            class="request-status"
            [ngClass]="facade.statusBadgeClass(r.status)"
            >{{ facade.statusLabelKey(r.status) | translate }}</span
          >
        </div>
      </div>

      @if (facade.agreedScheduleAt(r) || facade.preferredScheduleAt(r)) {
        <p class="order-header__schedule">
          @if (facade.agreedScheduleAt(r); as agreedAt) {
            <span
              >{{ 'admin.storageRequests.orderScheduledAt' | translate }}:
              {{ agreedAt | date: 'dd.MM.yyyy, HH:mm' }}</span
            >
          } @else if (
            facade.showPreferredSchedulePending(r) &&
              facade.preferredScheduleAt(r);
            as preferredAt
          ) {
            <span
              >{{ 'admin.storageRequests.preferredAt' | translate }}:
              {{ preferredAt | date: 'dd.MM.yyyy, HH:mm' }}</span
            >
            <span>{{
              'admin.storageRequests.preferredAtPendingHint' | translate
            }}</span>
          }
        </p>
      }
    </div>

  </div>
}
